// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles-fef46f7d":"d917aaf9","styles-e96e9bea":"32755dfd"}[chunkId] + ".css";
};